export default "__VITE_ASSET__CQr_6EBo__"